/**
 * Impl dos use cases de artefatos de cobrança por parcela (commerce).
 *
 * @since G.5.23
 */
import type { ParcelaPix, ParcelaBoleto } from '@/domain/model/ParcelaArtifact';
import type { ParcelaArtifactGateway } from '@/application/port/out/ParcelaArtifactGateway';
import type { IssueParcelaPixUseCase, IssueParcelaBoletoUseCase } from '@/application/port/in/ParcelaArtifactUseCase';

export class IssueParcelaPix implements IssueParcelaPixUseCase {
  constructor(private readonly g: ParcelaArtifactGateway) {}
  execute(parcelaId: string): Promise<ParcelaPix> { return this.g.issuePix(parcelaId); }
}
export class IssueParcelaBoleto implements IssueParcelaBoletoUseCase {
  constructor(private readonly g: ParcelaArtifactGateway) {}
  execute(parcelaId: string): Promise<ParcelaBoleto> { return this.g.issueBoleto(parcelaId); }
}
